module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("文档是用什么工具编写的？")]), _vm._v(" "), _c('p', [_vm._v("早期版本使用的是 "), _c('a', {
    attrs: {
      "href": "https://docute.js.org"
    }
  }, [_vm._v("Docute")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://github.com/egoist"
    }
  }, [_vm._v("egoist")]), _vm._v("。在"), _c('code', [_vm._v("Docute")]), _vm._v("基础上做了一点样式修改。")]), _vm._v(" "), _c('p', [_vm._v("2.2.1 后面版本出于 "), _c('code', [_vm._v("SEO")]), _vm._v(" 考虑使用 "), _c('code', [_vm._v("Vue")]), _vm._v(" 的服务端渲染，使用的框架同样是 "), _c('a', {
    attrs: {
      "href": "https://github.com/egoist"
    }
  }, [_vm._v("egoist")]), _vm._v(" 开发的 "), _c('a', {
    attrs: {
      "href": "https://github.com/ream/ream"
    }
  }, [_vm._v("ream")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("文档部分样式参照了 "), _c('a', {
    attrs: {
      "href": "https://eggjs.org/"
    }
  }, [_vm._v("eggjs.org")]), _vm._v("，表示感谢。")]), _vm._v(" "), _c('p', [_vm._v("因此目前无论是组件还是文档都是完全基于 "), _c('code', [_vm._v("Vue")]), _vm._v("，cool right?")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48c7c348", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-48c7c348"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/document-framework-43.vue
// module id = 2210
// module chunks = 444